import React from 'react';
import { Routes, Route } from "react-router-dom";
import IssuerListingCalendarMain from './listing-calendar/listing-calendar-main';

const IssuerListingCalendar = () => {
  return (
    <Routes>
      <Route index element={<IssuerListingCalendarMain />} />
    </Routes>
  )
}

export default IssuerListingCalendar;
